import {
    VENUES_REQUEST, VENUES_SUCCESS, VENUES_FAILURE,
    LAYOUTS_REQUEST, LAYOUTS_SUCCESS, LAYOUTS_FAILURE,
    LAYOUT_DETAIL_REQUEST, LAYOUT_DETAIL_SUCCESS, LAYOUT_DETAIL_FAILURE,
    VENUE_MUTATION_PENDING, VENUE_MUTATION_DONE
} from '../actions/venues';

const defaultState = {
    venues: [],
    // layoutsByVenue[venueId] = [ { LayoutId, ... } ]
    layoutsByVenue: {},
    // currentLayout = full layout detail (with LayoutData JSON string)
    currentLayout: null,
    isLoading: false,
    isMutating: false,
    error: ''
};

export default function venuesReducer(state = defaultState, action) {
    switch (action.type) {
        case VENUES_REQUEST:
            return { ...state, isLoading: true, error: '' };
        case VENUES_SUCCESS:
            return { ...state, isLoading: false, venues: action.payload.venues };
        case VENUES_FAILURE:
            return { ...state, isLoading: false, error: action.payload };

        case LAYOUTS_REQUEST:
            return { ...state, isLoading: true, error: '' };
        case LAYOUTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                layoutsByVenue: {
                    ...state.layoutsByVenue,
                    [action.payload.venueId]: action.payload.layouts
                }
            };
        case LAYOUTS_FAILURE:
            return { ...state, isLoading: false, error: action.payload };

        case LAYOUT_DETAIL_REQUEST:
            return { ...state, isLoading: true, error: '', currentLayout: null };
        case LAYOUT_DETAIL_SUCCESS:
            return { ...state, isLoading: false, currentLayout: action.payload.layout };
        case LAYOUT_DETAIL_FAILURE:
            return { ...state, isLoading: false, error: action.payload };

        case VENUE_MUTATION_PENDING:
            return { ...state, isMutating: true };
        case VENUE_MUTATION_DONE:
            return { ...state, isMutating: false };

        default:
            return state;
    }
}
